import { format, parseISO } from 'date-fns';

// Renders a YYYY-MM-DD (or ISO datetime) value as a local-safe display date.
export const displayDate = (value) => {
  if (!value) return '-';
  try {
    return format(parseISO(String(value).slice(0, 10)), 'MMM d, yyyy');
  } catch {
    return '-';
  }
};
